module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
  "use strict";

  require("../../../../../area/model/promo2/components/login-wizard/widget/recaptcha.es")(fox);

  var _ = {
    getTranslation: function (alias) {
      var translation = {
        errorAgreeOperatorAgreement: fox.i18n.getTranslation(
          "errorAgreeOperatorAgreement",
          "You must agree to the Website Operator Agreement",
          "errors",
        ),
        fieldIsRequired: fox.i18n.getTranslation(
          "fieldIsRequired",
          "This field is required",
          "errors",
        ),
        errorDomainName: fox.i18n.getTranslation(
          "errorDomainName",
          "That doesn't appear to be a valid domain name",
          "errors",
        ),
        errorNameForSocial: fox.i18n.getTranslation(
          "errorNameForSocial",
          "It's not a valid name for",
          "errors",
        ),
        errorPhoneNumber: fox.i18n.getTranslation(
          "errorPhoneNumber",
          "That doesn't appear to be a valid phone number",
          "errors",
        ),
        errorPhoneCode: fox.i18n.getTranslation(
          "errorPhoneCode",
          "That doesn't appear to be a valid phone code",
          "errors",
        ),
      };

      return translation[alias] || "";
    },
  };

  fox.registerWidget(
    "Registration_Form",
    {
      configure: function () {
        this.domainIsAvailable = false;
        this.regApiInProgress = false;
        this.domainApiInProgress = false;

        this.registerOptions("", {
          autoRender: true,
          template: "registration_step2_form",
          container: ".reg-step2-popup",
          "widgets.form": {
            widget: "Form",
            autoApply: true,
            customVisualHandling: true,
            methods: {
              send: "registration.register",
            },
            formElements: {
              domain: {
                element: '[name="domain"]',
              },
              agency: {
                element: '[name="agency"]',
              },
              promoCode: {
                element: '[name="promoCode"]',
              },
              heardFrom: {
                element: '[name="heardFrom"]',
              },
              phoneCode: {
                element: '[name="phone[code]"]',
              },
              phoneNumber: {
                element: '[name="phone[number]"]',
              },
              follow_twitter: {
                element: '[name="follow_twitter"]',
                defaultValue: true,
              },
              name: {
                element: '[name="name"]',
              },
              skinType: {
                element: '[name="skinType"]',
              },
            },
            "hooks.onResponse": fox.bind(function (data) {
              setTimeout(
                fox.bind(function () {
                  this.togglePreloader("hide");
                  this.regApiInProgress = false;

                  if (data.response.success) {
                    fox.site.gotoPage("congratulations");
                    fox.cookie.set("showInformationPopup", 1);
                    document.location.reload(true);
                  } else if (this.recaptcha && this.recaptcha.isNeed()) {
                    this.recaptcha.load("onError");
                  }
                }, this),
                2000,
              );
            }, this),
          },

          "widgets.recaptcha": {
            widget: "RecaptchaFox",
          },

          "widgets.clientInfoApi": {
            widget: "Api",
            method: "Client.getShortData",
          },

          "widgets.profileInfoApi": {
            widget: "Api",
            method: "ProfileInfo.getData",
          },

          handleWom: {
            handleProfileApi: {
              widget: "#clientInfoApi",
              event: "success",
              callback: "handleProfileApi",
            },
            handleAccountApi: {
              widget: "#profileInfoApi",
              event: "success",
              callback: "handleProfileApi",
            },
          },

          handleDom: {
            submit: {
              target: ".submit",
              event: "click",
              callback: "submit",
            },
            checkField: {
              target: "input.not-empty",
              event: "blur",
              callback: "checkField",
            },
            checkAgreement: {
              target: 'input[name="agreement"]',
              event: "change",
              callback: "checkAgreement",
            },
            handleSelectChange: {
              target: ".im-types-select",
              event: "change",
              callback: "handleSelectChange",
            },
            handleMessengerValueChange: {
              target: '[name="imid"]',
              event: "change",
              callback: "handleMessengerValueChange",
            },
          },

          "hooks.onAddedToDom": function () {
            this.recaptcha = this.rwom1("#recaptcha");

            if (this.recaptcha && this.recaptcha.isNeed()) {
              this.renderRecaptchaContainers();
              this.recaptcha.load();
            }

            this.getClientData();
            this.getProfileData();
            this.initTooltips();
          },
        });

        this.callParent("configure", arguments);
      },

      running: function () {
        this.xxxDomain = fox.cookie.get("xxx_domain");

        this.form = this.rwom1("#form");
        this.callParent("running", arguments);

        if (this.xxxDomain) {
          this.domainIsAvailable = true;
          this.setTemplateOptions({ xxx_domain: this.xxxDomain });
        }
      },

      submit: function () {
        this.handleSelectChange(
          fox.dom.selectFirst(".im-types-select", this.element),
        );
        this.checkDomain();
        if (!this.formIsValid()) {
          return;
        }

        if (!this.domainIsAvailable) {
          return;
        }

        if (this.xxxDomain) {
          this.form.setValue("domain", this.xxxDomain);
        }

        if (this.regApiInProgress) {
          return;
        }

        this.togglePreloader("show");

        var captchaPromise =
          this.recaptcha && this.recaptcha.isNeed()
            ? this.recaptcha.getToken("registration")
            : Promise.resolve(null);

        captchaPromise.then(
          fox.bind(function (captchaToken) {
            if (
              this.recaptcha &&
              this.recaptcha.isNeed() &&
              this.recaptcha.captchaVariant !== "invisible" &&
              !captchaToken
            ) {
              this.togglePreloader("hide");
              return;
            }

            var fields = this.form.collectData();
            for (var value in fields) {
              if (typeof fields[value] === "string") {
                fields[value] = fields[value].trim();
              }
            }

            if (this.recaptcha && this.recaptcha.isNeed() && captchaToken) {
              var captchaField =
                this.recaptcha.captchaVariant === "invisible"
                  ? "g-recaptcha-invisible-response"
                  : "g-recaptcha-response";

              this.form._preparedValues[captchaField] = captchaToken;
            }

            this.form.submit();

            this.regApiInProgress = true;
          }, this),
        );
      },

      renderRecaptchaContainers: function () {
        var root = this.element && this.element[0] ? this.element[0] : this.element;

        if (!root || fox.dom.selectFirst("#ReCaptchaFox", root)) {
          return;
        }

        var container = document.createElement("div");
        var submitContainer = fox.dom.selectFirst(".blue-bg", root);

        container.innerHTML =
          '<div id="ReCaptchaFoxInVisible" style="position:absolute;visibility:hidden;"></div>' +
          '<div id="ReCaptchaFox" style="display:none;margin:10px 0;text-align:center;"></div>';

        if (submitContainer && submitContainer.parentNode) {
          submitContainer.parentNode.insertBefore(container, submitContainer);
          return;
        }

        root.appendChild(container);
      },

      getClientData: function () {
        this.wom1("#clientInfoApi").send({});
      },

      getProfileData: function (argument) {
        this.wom1("#profileInfoApi").send({});
      },

      handleProfileApi: function (response, api, e) {
        var data = response.answer.response;

        if (api.getAlias() === "clientInfoApi") {
          if (data.name) {
            this.fillDomainField(data.name);

            if (data.project === "SnapCentro") {
              $("#profile-name").show();
              this.fillField("name", data.name);
              this.form.setValue("name", data.name);
            } else {
              this.form.rwom1("#name").disable();
            }
          }

          if (data.messenger && data.messenger.type === "twitter") {
            this.fillField("imid", data.messenger.identifier);
            this.setValueToMessengersSelect("twitter");
          }

          return;
        }
      },

      fillField: function (name, val) {
        var field = this.dom1('[name="' + name + '"]');

        if (!field) {
          return;
        }

        field.value = val;
      },

      fillDomainField: function (name) {
        if (this.xxxDomain) {
          this.domainIsAvailable = true;
          return;
        }

        var domainName = name.toLowerCase().replace(/[^a-zA-Z0-9\-]/g, "");

        this.fillField("domain", domainName);
        this.form.setValue("domain", domainName);
        this.checkDomain();
      },

      formIsValid: function (argument) {
        var result = true;

        var fields = fox.dom.select("input.not-empty", this.element[0]);

        fox.each(
          fields,
          function (elem) {
            if (
              elem.name === "name" &&
              this.form.rwom1("#" + elem.name).isDisabled
            ) {
              return;
            }
            var value = fox.trim(elem.value);

            this.hideError(elem.name);

            if (!value.length) {
              result = false;
              this.showError(elem.name, _.getTranslation("fieldIsRequired"));

              return;
            }

            if (
              elem.name === "phone[code]" &&
              !this._checkPhone(value, "code")
            ) {
              result = false;

              return;
            }

            if (
              elem.name === "phone[number]" &&
              !this._checkPhone(value, "number")
            ) {
              result = false;

              return;
            }

            if (elem.name === "imid") {
              var valid = true;
              if (
                this.form.getValue("imtypes[]") &&
                (value.match(/\s/) ||
                  !value.match(/^(\#)*[A-Za-z0-9-\_\.\,]+$/g))
              ) {
                valid = false;
              }

              if (!valid) {
                this.showError(
                  elem.name,
                  _.getTranslation("errorNameForSocial") +
                    " " +
                    (this.form.getValue("imtypes[]") || "twitter"),
                );

                return;
              }
            }

            if (elem.name === "domain") {
              if (this.xxxDomain) {
                return;
              }

              if (!this._checkDomain(value)) {
                result = false;
                return;
              }
            }

            if (elem.name === "agreement" && !elem.checked) {
              result = false;
              this.showError(
                elem.name,
                _.getTranslation("errorAgreeOperatorAgreement"),
              );

              return;
            }

            this.showSuccess(elem.name);
          },
          this,
        );

        return result;
      },

      checkField: function (elem) {
        var value = fox.trim(elem.value);

        if (!value.length) {
          this.showError(elem.name, _.getTranslation("fieldIsRequired"));

          return;
        }

        if (elem.name === "imid") {
          var valid = true;
          if (
            this.form.getValue("imtypes[]") &&
            (value.match(/\s/) || !value.match(/^(\#)*[A-Za-z0-9-\_\.\,]+$/g))
          ) {
            valid = false;
          }

          if (!valid) {
            this.showError(
              elem.name,
              _.getTranslation("errorNameForSocial") +
                " " +
                (this.form.getValue("imtypes[]") || "twitter"),
            );

            return;
          }
        }

        if (elem.name === "phone[code]") {
          this._checkPhone(value, "code");

          return;
        }

        if (elem.name === "phone[number]") {
          this._checkPhone(value);

          return;
        }

        this.hideError(elem.name);
        this.showSuccess(elem.name);

        if (elem.name === "domain") {
          this.checkDomain();
        }
      },

      // checkSkype: function(val) {
      // 	if (!!val.match(/^[a-zA-Z][a-zA-Z0-9\.,\-_:']{0,128}$/)) {
      // 		return true;
      // 	}

      // 	if (!!val.match(fox.regexp.email)) {
      // 		return true;
      // 	}

      // 	return false;
      // },

      checkAgreement: function (elem) {
        if (!elem.checked) {
          this.showError(
            elem.name,
            _.getTranslation("errorAgreeOperatorAgreement"),
          );

          return;
        }

        this.hideError(elem.name);
      },

      _checkDomain: function (str) {
        str = fox.trim(str);
        var regExp = /^[A-Za-z0-9-]+$/gi;

        if (!str.match(regExp)) {
          this.showError("domain", _.getTranslation("errorDomainName"));
          this.domainIsAvailable = false;

          return false;
        }

        return true;
      },

      _checkPhone: function (str, type) {
        var regExp = /^(\d)+$/g;
        var alias = "phone[number]";
        var msg = _.getTranslation("errorPhoneNumber");

        if (type === "code") {
          regExp = /(\d{1,3})$/g;
          alias = "phone[code]";
          msg = _.getTranslation("errorPhoneCode");
        }

        if (str.match(regExp)) {
          this.hideError(alias);
          this.showSuccess(alias);

          return true;
        }

        this.showError(alias, msg);
        return false;
      },

      checkDomain: function () {
        if (this.xxxDomain) {
          return;
        }

        if (this.domainApiInProgress) {
          return;
        }

        var api = this.getApi("registration_checkDomain", {
          method: "registration.checkDomain",
        });
        var input = fox.dom.selectFirst('[name="domain"]', this.element);
        var value = fox.trim(input.value);

        this.handleEvent(
          api,
          ["success", "error", "failure"],
          fox.bind(function (data, w, e) {
            this.domainApiInProgress = false;

            if (e === "failure" || e === "error") {
              console.warn("Something went wrong with check domain api", data);
              this.showError("domain", "Such domain already exists");
              this.domainIsAvailable = false;
              this.form.setValue("domain", "");
              return;
            }

            if (data.answer.response.success.errors.length === 0) {
              this.hideError("domain");
              this.showSuccess("domain");
              this.domainIsAvailable = true;
            } else {
              this.showError("domain", data.answer.response.success.errors);
              this.domainIsAvailable = false;
              this.form.setValue("domain", "");
            }
          }, this),
        );

        if (!this._checkDomain(value)) {
          return;
        }

        var data = {
          domain: value,
          xsid: $(input).attr("data-xsid"),
        };

        api.send({ domain: value, xsid: "" }, false);
        this.domainApiInProgress = true;
      },

      showError: function (name, msg) {
        var field = this.dom1('[name="' + name + '"]');

        if (!field) {
          return;
        }

        fox.dom.addClass("error", field);
        fox.dom.removeClass("success", field);
        fox.dom.selectFirst(".message", field.parentNode).innerHTML =
          msg || "&nbsp;";
      },

      hideError: function (name) {
        var field = this.dom1('[name="' + name + '"]');

        if (!field) {
          return;
        }

        fox.dom.removeClass("error", field);
        fox.dom.removeClass("success", field);
      },

      showSuccess: function (name) {
        var field = this.dom1('[name="' + name + '"]');

        if (!field) {
          return;
        }

        fox.dom.addClass("success", field);
      },

      handleSelectChange: function (el) {
        var option = el.options[el.selectedIndex];
        var placeholder = fox.dom.selectFirst(".placeholder", el.parentNode);

        placeholder.innerHTML = option.innerHTML;
        this.form.setValue(el.name, option.value);
        this.hideError("imid");
      },

      setValueToMessengersSelect: function (val) {
        var select = this.dom1(".im-types-select");
        var placeholder = fox.dom.selectFirst(
          ".placeholder",
          select.parentNode,
        );
        var options = fox.dom.select("option", select);
        var option;

        fox.each(options, function (opt) {
          opt.selected = false;
          if (opt.value === val) {
            opt.selected = true;
            option = opt;
          }
        });

        if (!option) {
          return;
        }

        select.value = option.value;
        placeholder.innerHTML = option.innerHTML;
        this.form.setValue("imtypes[]", option.value);
      },

      handleMessengerValueChange: function (el) {
        var type = this.form.getValue("imtypes[]")
          ? this.form.getValue("imtypes[]")
          : "twitter";
        this.form.setValue("imid[]", el.value);
      },

      togglePreloader: function (state) {
        var button = fox.dom.selectFirst(
          ".submit.button-with-spinner",
          this.element,
        );

        if (state === "hide") {
          fox.dom.removeClass("spin", button);
          return;
        }

        fox.dom.addClass("spin", button);
      },

      initTooltips: function () {
        if ($(this.element).tooltip("instance") === undefined) {
          $(this.element).tooltip({
            position: {
              my: "left-21% bottom-15",
              at: "left top",
              collision: "flipfit",
              using: function (pos, feedb) {
                $(this)
                  .css(pos)
                  .addClass(feedb.vertical)
                  .addClass(feedb.horizontal);
              },
            },
            tooltipClass: "gui-tooltip-type-1",
            items: ".gui-tooltip-link",
            content: function () {
              return $(this).find(".tt-content").html();
            },
          });
        }
      },
    },
    "Widget",
  );
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/sitepage/registration/form.js
// module id = 356
// module chunks = 2